import React from 'react';

import delv from 'dlv';
import styled from 'styled-components';

const Container = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 0 auto;
  display: grid;
  position: relative;
  background: ${Styles.color.white};
  padding: 2.5rem 0;
  h2 {
    text-align: center;
  }
`;

const TableRaw = styled.table`
  margin: 3rem auto;
  max-width: 100%;
  table-layout: fixed;
  word-break: break-all;
  border-collapse: collapse;

  & > thead > tr > th {
    height: 140px;
    white-space: nowrap;
    position: relative;

    &:nth-child(1) {
      margin: 0;
      padding: 0 10px;
      text-align: end;
    }

    & > div {
      position: absolute;
      inset-block-end: 0;
      inset-inline-end: 0;
      height: 45px;
      line-height: 50px;
      width: 150px;
      transform: rotate(315deg) translate(100%, 1px);
      transform-origin: bottom right;
      text-align: start;
      border-block-end: 1px solid ${Styles.color.grey.four};
    }
    & > div > span {
      display: inline-block;
    }
  }

  & > tbody > tr {
    height: 55px;
    &:hover {
      background: ${Styles.color.grey.five};
    }
  }
  & > tbody > tr > th {
    width: 150px;
    padding: 0 10px;
    white-space: nowrap;
    text-align: end;
  }

  & > tbody > tr > td {
    text-align: center;
    font-size: 0.875rem;
    width: 55px;
    word-wrap: break-word;
    overflow: hidden;
    border: 1px solid ${Styles.color.grey.four};
  }

  ${Styles.mobileSmall} {
    width: 90%;
    thead {
      display: none;
    }
    tbody,
    th,
    td,
    tr {
      display: block;
    }
    & > tbody > tr > th {
      width: 100%;
      text-align: start;
    }
    & > tbody > tr > td {
      width: 100%;
      text-align: end;
      border-width: 1px 0 0 0;
      border-color: ${Styles.color.grey.four};
    }
    & > tbody > tr {
      height: auto;
      margin-block-start: 1rem;
    }
    & > tbody {
      td:before {
        display: inline-block;
        float: inline-start;
        text-align: start;
      }
      td:nth-of-type(1):before {
        content: 'Calories (kcal)';
      }
      td:nth-of-type(2):before {
        content: 'Total Fat (g)';
      }
      td:nth-of-type(3):before {
        content: 'Saturated Fat (g)';
      }
      td:nth-of-type(4):before {
        content: 'Trans Fat (g)';
      }
      td:nth-of-type(5):before {
        content: 'Cholesterol (mg)';
      }
      td:nth-of-type(6):before {
        content: 'Sodium (mg)';
      }
      td:nth-of-type(7):before {
        content: 'Carbohydrates (g)';
      }
      td:nth-of-type(8):before {
        content: 'Fibre (g)';
      }
      td:nth-of-type(9):before {
        content: 'Sugar (g)';
      }
      td:nth-of-type(10):before {
        content: 'Protein (g)';
      }
      td:nth-of-type(11):before {
        content: 'Caffeine (mg)';
      }
    }
  }
`;

const getProducts = productList => {
  return productList.map(product => {
    return product._type === 'item'
      ? {
          name: product.name?.locale,
          nutrition: product.nutrition,
        }
      : product.products && getProducts(product.products);
  });
};

export const NutritionInfoWidget = props => {
  return (
    <Container>
      <h2>{delv(props, 'nutritionalSection.name.locale')}</h2>
      {delv(props, 'nutritionalSection.products').map(p => {
        return (
          <>
            <TableRaw>
              <thead>
                <tr>
                  <th>
                    <h3>{delv(p, 'name.locale')}</h3>
                  </th>
                  <th>
                    <div>
                      <span>Calories (kcal)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Total Fat (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Saturated Fat (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Trans Fat (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Cholesterol (mg)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Sodium (mg)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Carbohydrates (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Fibre (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Sugar (g)</span>
                    </div>
                  </th>
                  <th>
                    <div>
                      <span>Protein (g)</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {getProducts(delv(p, 'products')).map((r, index) => {
                  return (
                    <tr key={index}>
                      <th>{r.name}</th>
                      <td>{delv(r, 'nutrition.calories', '')}</td>
                      <td>{delv(r, 'nutrition.fat', '')}</td>
                      <td>{delv(r, 'nutrition.saturatedFat', '')}</td>
                      <td>{delv(r, 'nutrition.transFat', '')}</td>
                      <td>{delv(r, 'nutrition.cholesterol', '')}</td>
                      <td>{delv(r, 'nutrition.sodium', '')}</td>
                      <td>{delv(r, 'nutrition.carbohydrates', '')}</td>
                      <td>{delv(r, 'nutrition.fiber', '')}</td>
                      <td>{delv(r, 'nutrition.sugar', '')}</td>
                      <td>{delv(r, 'nutrition.proteins', '')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </TableRaw>
          </>
        );
      })}
    </Container>
  );
};
